var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.9998H21.6667V9.99984H26.6667V6.6665H21.6667V1.6665H18.3333V6.6665H13.3333V9.99984H18.3333M11.6667 29.9998C9.83334 29.9998 8.33334 31.4998 8.33334 33.3332C8.33334 35.1665 9.83334 36.6665 11.6667 36.6665C13.5 36.6665 15 35.1665 15 33.3332C15 31.4998 13.5 29.9998 11.6667 29.9998ZM28.3333 29.9998C26.5 29.9998 25 31.4998 25 33.3332C25 35.1665 26.5 36.6665 28.3333 36.6665C30.1667 36.6665 31.6667 35.1665 31.6667 33.3332C31.6667 31.4998 30.1667 29.9998 28.3333 29.9998ZM12 24.6665V24.4998L13.5 21.6665H25.8333C27 21.6665 28.1667 20.9998 28.6667 19.9998L35.1667 8.33317L32.3333 6.6665L25.8333 18.3332H14.1667L7.16667 3.33317H1.66667V6.6665H5.00001L11 19.3332L8.66667 23.3332C8.5 23.8332 8.33334 24.3332 8.33334 24.9998C8.33334 26.8332 9.83334 28.3332 11.6667 28.3332H31.6667V24.9998H12.3333C12.1667 24.9998 12 24.8332 12 24.6665Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlusWhite);
export default __webpack_public_path__ + "static/media/cardPlusWhite.6d657fcb877609641a1c1fbddf038377.svg";
export { ForwardRef as ReactComponent };